import { React, useEffect } from "react";
import "./bazi-expert-style.css";

const BaziExpertDialog = ({ open, onClose, title = "", baziPlate }) => {
  // // 鎖背景滾動 + ESC 關閉
  useEffect(() => {
    if (!open) return;

    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    const prevOverflow = document.body.style.overflow;
    const prevPaddingRight = document.body.style.paddingRight;

    document.body.style.overflow = "hidden";
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.paddingRight = prevPaddingRight;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  //用神 / 喜神 / 忌神（喜神、忌神為陣列，用「、」串接）
  const lucky = baziPlate?.luckyElements;
  const useful = lucky?.useful || "";
  const like = (lucky?.like || []).join("、");
  const nonLike = (lucky?.nonLike || []).join("、");

  //天干五合：後端 name 為「丁壬」顯示補「合」；同一種組合出現多次只算一種（去重）
  const ganHe = [
    ...new Set((baziPlate?.tianGanHe || []).map((h) => `${h.name}合`)),
  ];

  //地支關係（含三刑/自刑）來源
  const aspects = baziPlate?.diZhiAspects || {};
  const POS_LABEL = { year: "年柱", month: "月柱", day: "日柱", time: "時柱" };
  //每筆顯示「柱對-關係名」，例：月柱日柱-子丑合
  const fmtRel = (arr) =>
    (arr || []).map(
      (x) => `${x.positions.map((p) => POS_LABEL[p]).join("")}-${x.name}`,
    );
  const liuHe = fmtRel(aspects.liuHe);
  const banSanHe = fmtRel(aspects.banSanHe);
  const liuChong = fmtRel(aspects.liuChong);
  const liuHai = fmtRel(aspects.liuHai);

  //三刑：依類型顯示「無禮/無恩/恃勢之刑(地支)」，去重
  const XING_LABELS = {
    wuLi: "無禮之刑",
    wuEn: "無恩之刑",
    shiShi: "恃勢之刑",
  };
  const sanXing = [
    ...new Set(
      ["wuLi", "wuEn", "shiShi"].flatMap((t) =>
        (aspects[t] || []).map((x) => `${XING_LABELS[t]}(${x.zhis.join("")})`),
      ),
    ),
  ];
  //自刑，名稱去重
  const ziXing = [...new Set((aspects.ziXing || []).map((x) => x.name))];

  return (
    <div className="backdrop" onMouseDown={onClose}>
      <div className="expert-dialog">
        <div className="close-btn" onClick={onClose}>
          <img src={`/images/ic-white-close.png`} alt="close" />
        </div>

        <div
          className="expert-content"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="title">{title}</div>

          {/*動態生成描述*/}
          <div className="expert-list">
            <div>{`用神: ${useful}`}</div>
            <div>{`喜神: ${like}`}</div>
            <div>{`忌神: ${nonLike}`}</div>

            <div>{`天干五合${ganHe.length ? `（${ganHe.length}）` : ""}：${
              ganHe.length ? ganHe.join("、") : "無"
            }`}</div>

            <div>{`地支六合：${liuHe.length ? liuHe.join("、") : "無"}`}</div>
            <div>{`地支半三合：${banSanHe.length ? banSanHe.join("、") : "無"}`}</div>
            <div>{`地支六沖：${liuChong.length ? liuChong.join("、") : "無"}`}</div>
            <div>{`地支六害：${liuHai.length ? liuHai.join("、") : "無"}`}</div>

            <div>{`三刑：${sanXing.length ? sanXing.join("、") : "無"}`}</div>
            <div>{`自刑：${ziXing.length ? ziXing.join("、") : "無"}`}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaziExpertDialog;
